
import { createContext, useContext, useState } from "react";

const SearchToggleContext = createContext();

export const SearchToggleProvider = ({ children }) => {
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  return (
    <SearchToggleContext.Provider value={{ isSearchVisible, setIsSearchVisible }}>
      {children}
    </SearchToggleContext.Provider>
  );
};

export const useSearchToggle = () => useContext(SearchToggleContext);
